module.exports = __webpack_public_path__ + "media/Images/icon-money-currency-05ff9ae8feba4976072d819e33e8bda1.svg";